/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { IErrorResponse, ProductGroup } from '@/types';
import type { PaginationResponse } from '@/types/PaginationResponse';

import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import { urls } from '@/statics';

const useSearch = (queries: { fuzzy_search: string; pageSize: number }) =>
  useQuery<PaginationResponse<ProductGroup>, IErrorResponse>({
    queryKey: [`${urls.productGroups}?${queryString.stringify(queries)}`],
    enabled: Boolean(queries.fuzzy_search),
  });

export default useSearch;
